export default __webpack_public_path__ + "cce5625b56ec678e42021270b84ef400.ttf";